var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sort)?_c('th',{class:[
    _vm.forceAlignRight ? _vm.$style.textAlignRight : _vm.$style.textAlign,
    _vm.showArrow ? _vm.$style.enableCursor : _vm.$style.disableCursor,
    _vm.getClassNames()
  ],on:{"click":function($event){return _vm.$emit('sort', _vm.column)}}},[_vm._t("default"),(_vm.showArrow)?_c('div',{class:_vm.sortOrder === 'ASC' ? _vm.$style.arrowUp : _vm.$style.arrowDown}):_vm._e()],2):_c('th',{class:_vm.$style.disableCursor},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }